
import { Component, OnInit, EventEmitter, ViewEncapsulation, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/primeng';
import { UserService } from '../../../services/user.service';
import { environment } from '../../../../../environments/environment';
import { FoldersService } from '../services/folders.service';
import { FilesService } from '../services/files.service';

@Component({
  selector: 'app-document-picker',
  templateUrl: './document-picker.component.html',
  styleUrls: ['./document-picker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentPickerComponent implements OnInit {

  docFiles: any[] = [];
  docFolder: any;
  docFolderChanged = new EventEmitter<any>();
  docSelectedIds: string = '';
  fsFolderId: number = 0;
  userId: number = 0;
  isSingleFile: boolean = false;

  objectId?: number;
  tableName?: string;
  service?: string;
  isPrivated?: boolean;

  constructor(
    @Optional() public ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private _userService: UserService,
    private _foldersService: FoldersService,
    private _filesService: FilesService,
  ) {
  }

  ngOnInit() {
    if (this.config && this.config.data) {
      if (typeof this.config.data.multiple !== 'undefined') {
        this.isSingleFile = !this.config.data.multiple;
      }
      this.objectId = this.config.data.objectId || 0;
      this.tableName = this.config.data.tableName || '';
      this.service = this.config.data.service || 'work';
      this.isPrivated = this.config.data.isPrivated;
    }

    this.userId = this._userService.getBasicUserInfo().userId;
    this._foldersService.GetRootFolder().then(rs => {
      if (rs.status) {
        this.docFolder = rs.data;
        this.fsFolderId = rs.data.id;
        this.onChangeDocFolder(this.fsFolderId);
      }
    });
  }

  onChangeDocFolder(folderId: number) {
    this.docFiles = [];
    this.fsFolderId = folderId;

    // Get folder info for breadcrumb
    this._foldersService.getDetail(folderId).then(rs => {
      if (rs.status) {
        if (rs.data) {
          this.docFolder = rs.data;
          this.docFolderChanged.next({ idPath: rs.data.idPath, displayPath: rs.data.displayPath });
        }
      }
    });

    // Get child folders
    this._foldersService.GetByParentId(folderId, this.objectId, this.tableName, this.service, this.isPrivated).then(rx => {
      if (rx.status) {
        rx.data.forEach(item => {
          this.docFiles.push({
            id: item.id,
            fileName: item.name,
            createdDate: item.createdDate,
            isFolder: true
          });
        });
      }

      // Get files in folder
      this._filesService.GetByFolderId(folderId, this.objectId, this.tableName, this.service, this.isPrivated).then(rt => {
        if (rt.status) {
          rt.data.forEach(item => {
            let fileItem: any = {
              id: item.id,
              fileName: item.fileName,
              extention: item.extention,
              createdByUser: item.createdByUser,
              createdDate: item.createdDate,
              size: item.size,
              path: item.path,
              isFolder: false,
              type: item.type
            };
            const tmp = ',' + this.docSelectedIds;
            if (tmp.indexOf(',' + fileItem.id + ',') >= 0) {
              fileItem.checked = true;
            }
            this.docFiles.push(fileItem);
          });
        }
      });
    });
  }

  onDocFolderClick(item) {
    this.onChangeDocFolder(item.id);
  }

  onSelectDocItem(ev) {
    this.docSelectedIds = ev;
  }

  onSelectDocFolderFromBreadcrumb(selectedFolder: any) {
    if (selectedFolder.id == 0) {
      this._foldersService.GetRootFolder().then(rs => {
        if (rs.status) {
          this.docFolder = rs.data;
          this.fsFolderId = rs.data.id;
          this.onChangeDocFolder(this.fsFolderId);
        }
      });
    } else {
      this.onChangeDocFolder(selectedFolder.id);
    }
  }

  onDocSelected() {
    if (this.docSelectedIds) {
      this.ref.close(this.docSelectedIds);
    }
  }

  closePopup() {
    this.ref.close(null);
  }

  urlImageAvatar(path: string) {
    return `${environment.apiDomain.fileEndpoint}${path}`;
  }
}
